export interface BatchStatisticsRegUsrRequest {
  registDateFrom: string
  registDateTo: string
  registTitle: string
  lastLendDateFrom: string
  lastLendDateTo: string
  registBranchCodeFrom: string
  registBranchCodeTo: string
  areaCodeFrom: string
  areaCodeTo: string
  addressCodeForm: string
  addressCodeTo: string
  yearAgeEnabled: boolean
  xItem: string
  yItem1: string
  yCheck1: boolean[]
  yItem2: string
  yCheck2: boolean[]
  yItem3: string
  yCheck3: boolean[]
  yItem4: string
  yCheck4: boolean[]
  isOutputFull: boolean
  registMemo: string
  batchType: string
}

export function BatchStatisticsRegUsrRequestToJSON(
  value: BatchStatisticsRegUsrRequest
): any {
  return {
    regist_date_from: value.registDateFrom,
    regist_date_to: value.registDateTo,
    title: value.registTitle,
    last_lend_date_from: value.lastLendDateFrom,
    last_lend_date_to: value.lastLendDateTo,
    regist_branch_code_from: value.registBranchCodeFrom,
    regist_branch_code_to: value.registBranchCodeTo,
    area_code_from: value.areaCodeFrom,
    area_code_to: value.areaCodeTo,
    address_code_from: value.addressCodeForm,
    address_code_to: value.addressCodeTo,
    year_age_enabled: value.yearAgeEnabled,
    x_item: value.xItem,
    y_item1: value.yItem1,
    y_check1: value.yCheck1,
    y_item2: value.yItem2,
    y_check2: value.yCheck2,
    y_item3: value.yItem3,
    y_check3: value.yCheck3,
    y_item4: value.yItem4,
    y_check4: value.yCheck4,
    is_output_full: value.isOutputFull,
    memo: value.registMemo,
    batch_type: value.batchType
  }
}
